var _excluded = ["className", "node"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { UploadcareFile } from '@prezly/uploadcare';
import classNames from 'classnames';
import { Download } from "../../icons/index.mjs";
import { formatBytes } from "../../lib/index.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Attachment(_ref) {
  var {
      className,
      node
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var {
    description,
    file
  } = node;
  var attachment = UploadcareFile.createFromPrezlyStoragePayload(file);
  var isUsingCustomTitle = Boolean(description);
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    id: "attachment-".concat(file.uuid),
    className: classNames('prezly-slate-attachment', className),
    href: attachment.downloadUrl
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "prezly-slate-attachment__content",
      children: [/*#__PURE__*/_jsx("div", {
        className: "prezly-slate-attachment__icon-container",
        children: /*#__PURE__*/_jsx(Download, {
          className: "prezly-slate-attachment__icon"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "prezly-slate-attachment__details",
        children: [/*#__PURE__*/_jsx("div", {
          className: "prezly-slate-attachment__title",
          children: isUsingCustomTitle ? description : file.filename
        }), /*#__PURE__*/_jsx("div", {
          className: "prezly-slate-attachment__subtitle",
          children: isUsingCustomTitle ? "".concat(file.filename, " - ").concat(formatBytes(file.size)) : formatBytes(file.size)
        })]
      })]
    })
  }));
}